import { TiptapEditorHTMLView } from '@amzn/awscat-editor';
import { Box, Button, ButtonProps, Header, SpaceBetween } from '@amzn/awsui-components-core';
import { Epic } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import constants from '../../../common/constants';
import '../../../resources/styles/scss/components/common/EpicEditor.css';
import { getText } from '@amzn/awscat-editor';
import { MoveVerticallyHandle } from '../MoveVerticallyHandle';

interface Props {
  epic: Epic;
  isEditable: boolean;
  onEpicChanged: (epic: Epic) => void;
  onEpicDeleteClick: (epic: Epic) => void;
  onEpicEditClick: (epic: Epic) => void;
}

class EpicHeader extends React.Component<Props> {
  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
  }

  public render() {
    const { epic, isEditable } = this.props;
    const { description } = epic;

    const headerActions = isEditable ? (
      <SpaceBetween direction="horizontal" size="xxxs">
        <div className="edit-epic-icon">
          <svg
            onClick={this.handleEditEpic}
            width="20"
            height="20"
            viewBox="0 0 2048 2048"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill="#444" d={constants.EDIT_ICON_URI} />
          </svg>
        </div>
        <div className="delete-epic-icon">
          <Button
            variant="icon"
            iconUrl={'/images/icon-delete.svg'}
            iconAlt="Delete epic"
            ariaLabel="Delete epic"
            onClick={this.handleEpicRemoved}
          />
        </div>
        <MoveVerticallyHandle />
      </SpaceBetween>
    ) : null;

    const title = <TiptapEditorHTMLView model={getText(epic.title)} />;
    const descriptionHTML = description ? (
      <Box variant="small" color="text-body-secondary">
        <TiptapEditorHTMLView model={description} />
      </Box>
    ) : null;

    return (
      <Header variant="h3" actions={headerActions}>
        {title}
        {descriptionHTML}
      </Header>
    );
  }

  private handleEditEpic = (event: React.MouseEvent<SVGSVGElement>) => {
    event.stopPropagation();
    const { epic, onEpicEditClick } = this.props;
    onEpicEditClick(epic);
  };

  private handleEpicRemoved = (event: CustomEvent<ButtonProps.ClickDetail>) => {
    event.stopPropagation();
    const { epic, onEpicDeleteClick } = this.props;
    const confirmText =
      epic.tasks.length === 0
        ? constants.EPIC_REMOVE_CONFIRM_WITHOUT_TASKS
        : constants.EPIC_REMOVE_CONFIRM_WITH_TASKS;
    if (confirm(confirmText) && onEpicDeleteClick) {
      onEpicDeleteClick(epic);
    }
  };
}

export default EpicHeader;
